<script>
	let name = 'World';
</script>

<h1>Hello {name}!</h1>
